import React, {useState} from 'react'
import { Alert } from 'react-bootstrap'

const AlertDismissible = ({type = 'danger', title, message, dismiss=true }) => {
  const [show, setShow] = useState(true);

  if (show) {
    return (
      <Alert variant={type} onClose={() => setShow(false)} dismissible={dismiss} className="mt-3">
         <Alert.Heading>{ title }</Alert.Heading> 
        <p>
          { message }
        </p>
      </Alert>
    );
  } return null
}

export default AlertDismissible